import React from 'react';
import styled from 'styled-components';

const Container = styled.button`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }

  width: 100%;
  background-color: white;
  border-bottom: 2px solid #01288f;
  border-radius: 4px;
  margin-bottom: 25px;
  box-shadow: 0 0 10px -2px #ccc;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  text-align: left;
`;

const InnerContiner = styled.div`
  padding: 15px;
  &::-moz-focus-inner {
    border: 0;
  }
  &:focus {
    outline: none;
  }
`;

const Title = styled.h2`
  font-size: 15px !important;
  margin-bottom: 10px;
  color: #404040 !important;
  line-height: 24px !important;
  font-weight: 500 !important;
`;

const Location = styled.div`
  font-size: 12px !important;
  color: #999;
  line-height: 1.7em !important;
`;

const Event = ({ title, details, onClick }) => (
  <Container tabIndex="0" onClick={onClick}>
    <InnerContiner tabIndex="-1">
      <Title>{title}</Title>
      <Location dangerouslySetInnerHTML={{ __html: details }} />
    </InnerContiner>
  </Container>
);

export default Event;
